import { z } from 'zod';

export const CandidateEngagementCountSchema = z.object({
  engagements: z.number().nonnegative().int(),
  engagementsTotal: z.number().nonnegative().int(),
  pastInterestHistory: z.number().nonnegative().int(),
  pastSubmissionHistory: z.number().nonnegative().int(),
  pastEngagementHistory: z.number().nonnegative().int(),
  pastInterestHistoryTotal: z.number().nonnegative().int(),
  pastSubmissionHistoryTotal: z.number().nonnegative().int(),
  pastEngagementHistoryTotal: z.number().nonnegative().int(),
});

export type CandidateEngagementCount = z.infer<
  typeof CandidateEngagementCountSchema
>;
